import React from 'react';

export const BoxcryptorLogo = (props: React.SVGProps<SVGSVGElement>) => {
  const { className, ...other } = props;
  return (
    <svg viewBox="0 0 227 227" {...other}>
      <g id="Layer-1">
        <g transform="matrix(-0.0345388,0.999403,0.999403,0.0345388,137.75,108.638)">
          <path d="M11.332,-15.288C10.887,-8.412 7.889,-2.272 3.303,2.235L11.332,10.828C18.113,4.265 22.523,-4.764 23.085,-14.882L11.332,-15.288Z" />
        </g>
        <g transform="matrix(0.999204,0.0398888,0.0398888,-0.999204,92.6484,119.219)">
          <path d="M0.522,0.058C-6.264,6.626 -10.675,15.668 -11.227,25.812L0.522,26.281C0.94,19.385 3.921,13.231 8.495,8.708L0.522,0.058Z" />
        </g>
        <g transform="matrix(-0.733275,0.679932,0.679932,0.733275,117.372,125.431)">
          <path d="M1.682,-19.795C1.26,-13.4 -1.422,-7.143 -6.313,-2.324L1.682,6.3C8.944,-0.722 12.887,-9.929 13.434,-19.322L1.682,-19.795Z" />
        </g>
        <g transform="matrix(0.999187,-0.0403089,-0.0403089,-0.999187,149.863,119.211)">
          <path d="M-0.525,0.058C6.238,6.603 10.646,15.604 11.223,25.707L-0.525,26.182C-0.968,19.318 -3.95,13.193 -8.513,8.691L-0.525,0.058Z" />
        </g>
        <g transform="matrix(0.999306,0.0372547,0.0372547,-0.999306,147.793,91.3065)">
          <path d="M0.483,-0.073C-0.019,6.697 -2.995,12.737 -7.519,17.186L0.483,25.803C7.211,19.301 11.611,10.37 12.237,0.35L0.483,-0.073Z" />
        </g>
        <g transform="matrix(0.733821,-0.679343,-0.679343,-0.733821,144.909,66.9478)">
          <path d="M-7.69,-0.62C-8.155,5.706 -10.834,11.883 -15.678,16.65L-7.69,25.28C-0.467,18.301 3.476,9.161 4.063,-0.175L-7.69,-0.62Z" />
        </g>
        <g transform="matrix(0.04046,-0.999181,-0.999181,-0.04046,110.227,50.2571)">
          <path d="M-14.698,-10.811C-15.175,-4.013 -18.145,2.051 -22.671,6.519L-14.698,15.165C-7.963,8.653 -3.562,-0.295 -2.947,-10.335L-14.698,-10.811Z" />
        </g>
        <g transform="matrix(-0.674813,-0.737989,-0.737989,0.674813,82.184,74.4285)">
          <path d="M-12.659,-14.802C-13.103,-8.464 -15.768,-2.272 -20.597,2.507L-12.659,11.189C-5.439,4.214 -1.494,-4.932 -0.911,-14.277L-12.659,-14.802Z" />
        </g>
        <g transform="matrix(0.991159,-0.132678,-0.132678,-0.991159,171.452,138.188)">
          <path d="M-2.995,0.277C9.844,10.366 18.964,25.214 21.475,42.618L-2.995,45.907C-4.596,35.253 -10.165,26.148 -17.992,19.895L-2.995,0.277Z" />
        </g>
        <g transform="matrix(-0.623135,0.782114,0.782114,0.623135,117.764,132.05)">
          <path d="M7.789,-25.836C8.729,-15.863 6.052,-5.536 -0.487,3.011L7.789,9.602C16.145,-1.229 19.548,-14.359 18.306,-27.021L7.789,-25.836Z" />
        </g>
        <g transform="matrix(-0.129481,0.991582,0.991582,0.129481,154.141,118.546)">
          <path d="M19.024,-29.849C17.418,-19.188 11.834,-10.072 3.986,-3.819L19.024,15.764C31.887,5.656 41.01,-9.227 43.506,-26.652L19.024,-29.849Z" />
        </g>
        <g transform="matrix(0.60554,-0.795815,-0.795815,-0.60554,197.839,68.1226)">
          <path d="M-25.04,-5.531C-11.273,5.274 -2.958,20.51 -0.579,36.612L-25.04,39.955C-26.562,30.108 -31.641,20.798 -39.992,14.119L-25.04,-5.531Z" />
        </g>
        <g transform="matrix(0.110923,-0.993829,-0.993829,-0.110923,145.073,34.6253)">
          <path d="M-19.09,-14.302C-11.357,-4.265 -7.28,8.607 -8.574,22.166L-19.09,20.993C-18.117,10.349 -21.304,0.247 -27.336,-7.668L-19.09,-14.302Z" />
        </g>
        <g transform="matrix(0.963447,-0.267898,-0.267898,-0.963447,86.8852,86.8382)">
          <path d="M-7.721,-2.506C-4.592,7.713 2.189,15.866 10.784,20.911L-7.721,53.668C-24.697,43.885 -38.076,27.767 -43.998,7.541L-7.721,-2.506Z" />
        </g>
        <g transform="matrix(0.970268,0.242034,0.242034,-0.970268,32.6723,88.8462)">
          <path d="M7.844,-0.594C2.865,20.547 6.665,41.757 16.916,59.154L7.844,64.604C-3.796,44.893 -8.107,20.843 -2.433,-3.124L7.844,-0.594Z" />
        </g>
        <g transform="matrix(0.215371,0.976532,0.976532,-0.215371,139.076,130.548)">
          <path d="M25.675,-23.066C29.393,-5.196 25.743,12.532 16.76,26.92L25.675,32.623C36.118,15.952 40.357,-4.618 36.01,-25.345L25.675,-23.066Z" />
        </g>
        <g transform="matrix(0.0785833,0.996908,0.996908,-0.0785833,156.657,137.548)">
          <path d="M33.143,-37.285C34.635,-15.513 27.385,4.878 14.354,20.403L33.143,36.433C50.272,16.099 59.789,-10.663 57.757,-39.233L33.143,-37.285Z" />
        </g>
      </g>
    </svg>
  );
};

export const boxcryptorLogoRawHtml = `<svg viewBox="0 0 227 227" >
      <g id="Layer-1">
        <g transform="matrix(-0.0345388,0.999403,0.999403,0.0345388,137.75,108.638)">
          <path d="M11.332,-15.288C10.887,-8.412 7.889,-2.272 3.303,2.235L11.332,10.828C18.113,4.265 22.523,-4.764 23.085,-14.882L11.332,-15.288Z" />
        </g>
        <g transform="matrix(0.999204,0.0398888,0.0398888,-0.999204,92.6484,119.219)">
          <path d="M0.522,0.058C-6.264,6.626 -10.675,15.668 -11.227,25.812L0.522,26.281C0.94,19.385 3.921,13.231 8.495,8.708L0.522,0.058Z" />
        </g>
        <g transform="matrix(-0.733275,0.679932,0.679932,0.733275,117.372,125.431)">
          <path d="M1.682,-19.795C1.26,-13.4 -1.422,-7.143 -6.313,-2.324L1.682,6.3C8.944,-0.722 12.887,-9.929 13.434,-19.322L1.682,-19.795Z" />
        </g>
        <g transform="matrix(0.999187,-0.0403089,-0.0403089,-0.999187,149.863,119.211)">
          <path d="M-0.525,0.058C6.238,6.603 10.646,15.604 11.223,25.707L-0.525,26.182C-0.968,19.318 -3.95,13.193 -8.513,8.691L-0.525,0.058Z" />
        </g>
        <g transform="matrix(0.999306,0.0372547,0.0372547,-0.999306,147.793,91.3065)">
          <path d="M0.483,-0.073C-0.019,6.697 -2.995,12.737 -7.519,17.186L0.483,25.803C7.211,19.301 11.611,10.37 12.237,0.35L0.483,-0.073Z" />
        </g>
        <g transform="matrix(0.733821,-0.679343,-0.679343,-0.733821,144.909,66.9478)">
          <path d="M-7.69,-0.62C-8.155,5.706 -10.834,11.883 -15.678,16.65L-7.69,25.28C-0.467,18.301 3.476,9.161 4.063,-0.175L-7.69,-0.62Z" />
        </g>
        <g transform="matrix(0.04046,-0.999181,-0.999181,-0.04046,110.227,50.2571)">
          <path d="M-14.698,-10.811C-15.175,-4.013 -18.145,2.051 -22.671,6.519L-14.698,15.165C-7.963,8.653 -3.562,-0.295 -2.947,-10.335L-14.698,-10.811Z" />
        </g>
        <g transform="matrix(-0.674813,-0.737989,-0.737989,0.674813,82.184,74.4285)">
          <path d="M-12.659,-14.802C-13.103,-8.464 -15.768,-2.272 -20.597,2.507L-12.659,11.189C-5.439,4.214 -1.494,-4.932 -0.911,-14.277L-12.659,-14.802Z" />
        </g>
        <g transform="matrix(0.991159,-0.132678,-0.132678,-0.991159,171.452,138.188)">
          <path d="M-2.995,0.277C9.844,10.366 18.964,25.214 21.475,42.618L-2.995,45.907C-4.596,35.253 -10.165,26.148 -17.992,19.895L-2.995,0.277Z" />
        </g>
        <g transform="matrix(-0.623135,0.782114,0.782114,0.623135,117.764,132.05)">
          <path d="M7.789,-25.836C8.729,-15.863 6.052,-5.536 -0.487,3.011L7.789,9.602C16.145,-1.229 19.548,-14.359 18.306,-27.021L7.789,-25.836Z" />
        </g>
        <g transform="matrix(-0.129481,0.991582,0.991582,0.129481,154.141,118.546)">
          <path d="M19.024,-29.849C17.418,-19.188 11.834,-10.072 3.986,-3.819L19.024,15.764C31.887,5.656 41.01,-9.227 43.506,-26.652L19.024,-29.849Z" />
        </g>
        <g transform="matrix(0.60554,-0.795815,-0.795815,-0.60554,197.839,68.1226)">
          <path d="M-25.04,-5.531C-11.273,5.274 -2.958,20.51 -0.579,36.612L-25.04,39.955C-26.562,30.108 -31.641,20.798 -39.992,14.119L-25.04,-5.531Z" />
        </g>
        <g transform="matrix(0.110923,-0.993829,-0.993829,-0.110923,145.073,34.6253)">
          <path d="M-19.09,-14.302C-11.357,-4.265 -7.28,8.607 -8.574,22.166L-19.09,20.993C-18.117,10.349 -21.304,0.247 -27.336,-7.668L-19.09,-14.302Z" />
        </g>
        <g transform="matrix(0.963447,-0.267898,-0.267898,-0.963447,86.8852,86.8382)">
          <path d="M-7.721,-2.506C-4.592,7.713 2.189,15.866 10.784,20.911L-7.721,53.668C-24.697,43.885 -38.076,27.767 -43.998,7.541L-7.721,-2.506Z" />
        </g>
        <g transform="matrix(0.970268,0.242034,0.242034,-0.970268,32.6723,88.8462)">
          <path d="M7.844,-0.594C2.865,20.547 6.665,41.757 16.916,59.154L7.844,64.604C-3.796,44.893 -8.107,20.843 -2.433,-3.124L7.844,-0.594Z" />
        </g>
        <g transform="matrix(0.215371,0.976532,0.976532,-0.215371,139.076,130.548)">
          <path d="M25.675,-23.066C29.393,-5.196 25.743,12.532 16.76,26.92L25.675,32.623C36.118,15.952 40.357,-4.618 36.01,-25.345L25.675,-23.066Z" />
        </g>
        <g transform="matrix(0.0785833,0.996908,0.996908,-0.0785833,156.657,137.548)">
          <path d="M33.143,-37.285C34.635,-15.513 27.385,4.878 14.354,20.403L33.143,36.433C50.272,16.099 59.789,-10.663 57.757,-39.233L33.143,-37.285Z" />
        </g>
      </g>
    </svg>`;
